import http from '../../utils/httpClient';
import moment from 'moment';
import swal from 'sweetalert2';
import router from '../../router';
const state = {
  swipe: [],
  selectSwipe: {},
  selectedCategoryId: '',
  selectedDeckIndex: -1,
  updateCardData: {},
  updateDeckData: {},
  isUpdating: false,
  cardData: {
    text: '',
    article: '',
  },
  addCardData: [
    {
      text: '',
      article: '',
    },
  ],
  addDeckData: {
    name: '',
  },
};
const getters = {};
const actions = {
  fetchSwipe({ commit, dispatch }, { page = 1, limit = 0 }) {
    commit('toggleStoreUpdate');
    http
      .GET(`/api/swipe?page=${page}&limit=${limit}`, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        const formatData = data.map(swipe => ({
          ...swipe,
          created_at: moment(swipe.created_at).format('MMMM D YYYY h:mm a'),
          updated_at: moment(swipe.updated_at).format('MMMM D YYYY h:mm a'),
        }));
        commit('storeSwipe', formatData);
      })
      .catch(err => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'swipe fetch swipe in this time please type again',
            type: 'error',
          },
          {
            root: true,
          },
        );
      })
      .finally(() => commit('toggleStoreUpdate'));
  },
  selectSwipe({ commit }, id) {
    commit('storeSelectSwipe', { id, sub_id: '' });
  },
  selectCategory({ commit }, id) {
    commit('storeSelectCategory', id);
  },
  fetchSingleSwipe({ commit, dispatch }, { id, sub_id }) {
    commit('toggleStoreUpdate');
    http
      .GET(`/api/swipe?category_id=${id}`, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        const formatData = data.map(swipe => ({
          ...swipe,
          created_at: moment(swipe.created_at).format('MMMM D YYYY h:mm a'),
          updated_at: moment(swipe.updated_at).format('MMMM D YYYY h:mm a'),
        }));
        commit('storeSwipe', formatData);
        commit('storeSelectSwipe', { id, sub_id });
      })
      .catch(err => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Cannot fetch swipe at this time. Please try again',
            type: 'error',
          },
          {
            root: true,
          },
        );
      })
      .finally(() => commit('toggleStoreUpdate'));
  },
  updateCardData({ commit }, { key, value }) {
    commit('storeUpdateCardData', {
      key,
      value,
    });
  },
  updateDeckData({ commit }, { key, value }) {
    commit('storeUpdateDeckData', {
      key,
      value,
    });
  },
  updateCard({ dispatch }, updateData) {
    if (Object.keys(updateData).length > 1) {
      http
        .PUT(
          '/api/choice',
          {
            ...updateData,
          },
          {
            isAuthorization: true,
          },
        )
        .then(({ data }) => {
          dispatch(
            'appConfig/toggleAlert',
            {
              message: 'Update Card Success.',
              type: 'success',
            },
            {
              root: true,
            },
          );
          dispatch('fetchSingleSwipe', { id: state.selectSwipe.category_id });
        })
        .catch(err => {
          dispatch(
            'appConfig/toggleAlert',
            {
              message: 'Failed to update card. Please Try again',
              type: 'error',
            },
            {
              root: true,
            },
          );
        });
    }
  },
  clearUpdateData({ commit }) {
    commit('clearStoreUpdateData');
  },

  deleteDeck({ dispatch, state }, id) {
    swal
      .fire({
        titleText: 'Confirm Delete Deck',
        showCancelButton: true,
        type: 'warning',
      })
      .then(result => {
        if (result.value) {
          http
            .DELETE(`/api/swipe/deck?_id=${id}`, {
              isAuthorization: true,
            })
            .then(({ data }) => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  message: 'Delete Successfully',
                  type: 'success',
                },
                { root: true },
              );
              dispatch('fetchSingleSwipe', {
                id: state.selectSwipe.category_id,
              });
            })
            .catch(err => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  message: 'Cannot delete deck. Please try again later !',
                  type: 'error',
                },
                { root: true },
              );
            });
        }
      });
  },
  deleteCard({ dispatch, state }, id) {
    swal
      .fire({
        titleText: 'Confirm Delete Card',
        showCancelButton: true,
        type: 'warning',
      })
      .then(result => {
        if (result.value) {
          http
            .DELETE(`/api/choice?_id=${id}`, {
              isAuthorization: true,
            })
            .then(({ data }) => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  message: 'Delete Successfully',
                  type: 'success',
                },
                { root: true },
              );
              dispatch('fetchSingleSwipe', {
                id: state.selectSwipe.category_id,
              });
            })
            .catch(err => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  message: 'Cannot delete card please try again later !',
                  type: 'error',
                },
                { root: true },
              );
            });
        }
      });
  },
  updateCreateCardData({ commit }, { key, value, index }) {
    commit('storeCreateCardData', {
      key,
      value,
      index,
    });
  },
  updateCreateSingleCardData({ commit }, { key, value }) {
    commit('storeCreateSingleCardData', {
      key,
      value,
    });
  },
  updateDeck({ dispatch }, updateData) {
    if (Object.keys(updateData).length > 1) {
      http
        .PUT('/api/swipe/deck', updateData, {
          isAuthorization: true,
        })
        .then(({ data }) => {
          dispatch(
            'appConfig/toggleAlert',
            {
              message: 'Edit Deck success',
              type: 'success',
            },
            {
              root: true,
            },
          );
          dispatch('fetchSingleSwipe', { id: state.selectSwipe.category_id });
        })
        .catch(err => {
          dispatch(
            'appConfig/toggleAlert',
            {
              message: 'Edit Deck failed please try again later',
              type: 'error',
            },
            {
              root: true,
            },
          );
        });
    }
  },
  updateCreateDeckData({ commit }, { key, value }) {
    commit('storeCreateDeckData', {
      key,
      value,
    });
  },
  addDeck({ dispatch }, { category_id, ...data }) {
    const createDeckData = {
      category_id,
      deck: {
        ...data.deck,
      },
      choice: [...data.cards],
    };
    http
      .POST('/api/swipe', createDeckData, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Create Deck success',
            type: 'success',
          },
          {
            root: true,
          },
        );
        dispatch('fetchSingleSwipe', { id: category_id });
        router.go({
          path: '/swipe/detail',
          query: {
            id: category_id,
          },
        });
      })
      .catch(err => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Create Deck failed',
            type: 'errpr',
          },
          {
            root: true,
          },
        );
      });
  },
  addCardByDeckId({ dispatch }, { category_id, deck_id, ...data }) {
    const createCardData = {
      _id: deck_id,
      choice: { ...data.card },
    };
    http
      .POST('/api/swipe/deck', createCardData, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Add Card success',
            type: 'success',
          },
          {
            root: true,
          },
        );
        dispatch('fetchSingleSwipe', { id: category_id });
        router.go({
          path: '/swipe/detail',
          query: {
            id: category_id,
          },
        });
      })
      .catch(err => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Add Card failed',
            type: 'error',
          },
          {
            root: true,
          },
        );
      });
  },
};
const mutations = {
  toggleStoreUpdate(state) {
    state.isUpdating = !state.isUpdating;
  },
  storeSwipe(state, swipeList) {
    state.swipe = swipeList;
  },
  storeSelectSwipe(state, { id, sub_id }) {
    if (id) {
      const index = state.swipe.findIndex(swipe => swipe.category_id === id);
      state.selectSwipe = state.swipe[index];
      if (sub_id) {
        const deckIndex = state.selectSwipe.decks.findIndex(
          deck => deck._id === sub_id,
        );
        state.selectedDeckIndex = deckIndex;
      }
    } else {
      delete state.selectSwipe;
    }
  },
  storeSelectCategory(state, value) {
    if (value) {
      state.selectedCategoryId = value;
    } else {
      delete state.selectedCategoryId;
    }
  },
  storeUpdateCardData(state, { key, value }) {
    state.updateCardData = {
      ...state.updateCardData,
      [key]: value,
    };
  },
  storeCreateCardData(state, { key, value, index }) {
    state.addCardData[index] = {
      ...state.addCardData[index],
      [key]: value,
    };
  },
  storeCreateSingleCardData(state, { key, value }) {
    state.addSingleCardData = {
      ...state.addSingleCardData,
      [key]: value,
    };
  },
  storeUpdateDeckData(state, { key, value }) {
    state.updateDeckData = {
      ...state.updateDeckData,
      [key]: value,
    };
  },
  storeCreateDeckData(state, { key, value }) {
    state.addDeckData = {
      ...state.addDeckData,
      [key]: value,
    };
  },
  clearStoreUpdateData(state) {
    Object.keys(state.updateCardData).forEach(key => {
      if (key != '_id') {
        delete state.updateCardData[key];
      }
    });
    Object.keys(state.updateDeckData).forEach(key => {
      if (key != '_id') {
        delete state.updateDeckData[key];
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
